import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/core/services/loader.service';
import { ClientService } from '@teem/core/services/client.service';
import { MixpanelService } from '@teem/services/mixpanel.service';
import { messages as i18n } from '@teem/core/constants/messages';
import { country as CountryApi } from '@teem/core/constants/api';
import { ClientForm } from '@teem/core/model-forms/client-form';
import { Client } from '@teem/core/models/client';


@Component({
  selector: 'app-add-client-modal',
  templateUrl: './add-client-modal.component.html',
  styles: []
})

export class AddClientModalComponent implements OnInit {
  
	@ViewChild('newClientForm') newClientForm: FormGroupDirective;
  clientForm: FormGroup;
	submitted: boolean = false;
	countryListApi: string = CountryApi.endPoint;
	count = 0;

  constructor(
  	private fb: FormBuilder,
  	private clientService: ClientService,
  	private loaderService: LoaderService,
		private mixpanelService: MixpanelService,
  	public activeModal: NgbActiveModal,
		private el:ElementRef) {
  }

  ngOnInit(): void {
  	this.clientForm = this.fb.group(new ClientForm(new Client()));
		this.count = 1;
  }
  
  onCountryChange(value: any) {
    if(value.calling_code) {
      this.clientForm.get('dial_code').setValue('+'+value.calling_code);
    }
  }

  onChangeField() {
    if (this.count == 1) {
      this.mixpanelService.track('client_add_start');
    }
    this.count = this.count + 1;
  }

  submit() {
  	if(this.clientForm.valid) {
  		this.submitted = true;
  		this.loaderService.startLoading();
  		this.clientService.create(this.clientForm.value).subscribe(data => {
  			this.loaderService.stopLoading();

  			this.clientForm.reset();
  			this.activeModal.close(data);
  			
        let clientPro = this.mixpanelService.getClientProperties(data);
        this.mixpanelService.track('client_add_success', clientPro);

  			Swal.fire(i18n.done,  i18n.client.client_saved, 'success');
        this.submitted = false;  			
  		}, err => {
        this.loaderService.stopLoading();

  			// Set server side error
        if(err.status === 422) {
          if(err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              this.clientForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
  		});
  	}
  }
}
